import type { JSX } from 'react';

import { Helmet } from 'react-helmet-async';

import { useI18n } from '@change-corgi/core/react/i18n';

export function Meta(): JSX.Element {
	const { translate } = useI18n();

	return (
		<Helmet>
			<meta property="title" content={translate('corgi.sap.meta_tags.title')} />
			<meta name="description" content={translate('corgi.sap.meta_tags.description')} />
		</Helmet>
	);
}
